<template>
    <div id="menu">
        <!-- <div class="logo"></div> -->
        <img class="logo" src="@/assets/img/flypig.svg" alt="">
        <ul>
            <li v-for="(list, index) in menuList" :key="index"  @mouseenter="list.img.now = list.img.hover" @mouseleave="list.img.now = list.img.default">
                <router-link :to="{ name: list.linkName,}" v-slot="{ isActive, href, navigate }" >
                    <a  :class="{active: isActive}" :href="href" @click="navigate">
                    <img class="list-icon" :src="isActive?list.img.hover:list.img.now" alt="">
                    <span class="list-title">{{list.title}}</span>
                    </a>
                </router-link>
                <div class="tip">
                    {{list.title}}
                </div>
            </li>
        </ul>
        <!-- <span class="setting">
            <img src="@/assets/img/component/menu/setting_gray.svg" alt="">
            <span>設定</span>
        </span> -->
        <!-- <span @click="toggleMenu">
            縮
        </span> -->
    </div>
</template>
<script>
export default {
    name: 'Menu',
    data () {
        return {
            menuList: [
                {
                    linkName: 'housestatusdefault',
                    img:{
                        now: require('@/assets/img/component/menu/home_gray.svg'),
                        default: require('@/assets/img/component/menu/home_gray.svg'),
                        hover: require('@/assets/img/component/menu/home_green.svg')
                    },
                    title: '房態首頁'
                },
                {
                    linkName: 'HouseManagementDefault',
                    img:{
                        now: require('@/assets/img/component/menu/hmgt_gray.svg'),
                        default: require('@/assets/img/component/menu/hmgt_gray.svg'),
                        hover: require('@/assets/img/component/menu/hmgt_green.svg')
                    },
                    title: '房源管理'
                },
                {
                    linkName: 'tenantRecommendMgtDefault',
                    img:{
                        now: require('@/assets/img/component/menu/recommend_gray.svg'),
                        default: require('@/assets/img/component/menu/recommend_gray.svg'),
                        hover: require('@/assets/img/component/menu/recommand_pink.svg')
                    },
                    title: '推薦房客'
                },
                {
                    linkName: 'BookingManagementdefault',
                    img:{
                        now: require('@/assets/img/component/menu/booking_gray.svg'),
                        default: require('@/assets/img/component/menu/booking_gray.svg'),
                        hover: require('@/assets/img/component/menu/booking_green.svg')
                    },
                    title: '預定管理'
                },
                {
                    linkName: 'leasemanagementdefault',
                    img:{
                        now: require('@/assets/img/component/menu/task_management_gray.svg'),
                        default: require('@/assets/img/component/menu/task_management_gray.svg'),
                        hover: require('@/assets/img/component/menu/task_management_green.svg')
                    },
                    title: '租約管理'
                },
                // {
                //     linkName: 'tenantManagementDefault',
                //     img:{
                //         now: require('@/assets/img/component/menu/tanant_management_gray.svg'),
                //         default: require('@/assets/img/component/menu/tanant_management_gray.svg'),
                //         hover: require('@/assets/img/component/menu/tanant_management_green.svg')
                //     },
                //     title: '租客管理'
                // },
                {
                    linkName: 'financialManagementDefault',
                    img:{
                        now: require('@/assets/img/component/menu/statistics_management_gray.svg'),
                        default: require('@/assets/img/component/menu/statistics_management_gray.svg'),
                        hover: require('@/assets/img/component/menu/statistics_management_green.svg')
                    },
                    title: '收支報表'
                },
                {
                    linkName: 'TaskManagementdefault',
                    img:{
                        now: require('@/assets/img/component/menu/task_gray.svg'),
                        default: require('@/assets/img/component/menu/task_gray.svg'),
                        hover: require('@/assets/img/component/menu/task_green.svg')
                    },
                    title: '委託房客'
                }
            ]
            // isClose: 0,
        }
    },
    mounted () {
        // console.log(this.$route)
    },
    methods: {
        // toggleMenu: function () {
        //     this.isClose = !this.isClose;
        //     // console.log('h')
        //     // let menu = document.getElementById('menu');
        //     // menu.style.width = '80px';
        //     // console.log(this.$children)
        // }
    }
}
</script>
<style scoped lang="scss">
    #menu{
        position: fixed;
        background: #fff;
        width: 186px;
        border-right: 1px solid #f0f0f0;
        height: 100%;
        text-align: center;
        z-index: 9;
        // transition: 0.2s;
        .logo{
            width: 60px;
            height: 60px;
            // margin-top: 20px;
            // margin-bottom: 60px;
            margin: 20px auto 54px;
            // background: #F05A3E;
            border-radius: 10px;
            // border: solid 1px #ff9100;
        }
        ul{
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 150px;
            li{
                position: relative;
                margin-bottom: 10px;
                display: flex;
                // justify-content: center;
                a{
                    width: 126px;
                    padding: 10px 0 10px 20px;
                    // transition: 0.2s;
                    display: flex;
                    align-items: center;
                    .list-icon{
                        margin-right: 10px;
                    }
                    .list-title{
                        opacity: 0.8;
                        color: #a8a5a4;
                    }
                }
                a.active,
                a:hover{
                    border-radius: 26.5px;
                    background-color: #fff9f1;
                    .list-title{
                        opacity: 1;
                        color: #292625;
                        font-weight: 500;
                    }
                }
                .tip{
                    position: absolute;
                    background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iODRweCIgaGVpZ2h0PSIzNnB4IiB2aWV3Qm94PSIwIDAgODQgMzYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+Q29tYmluZWQgU2hhcGU8L3RpdGxlPgogICAgPGcgaWQ9IuaIv+aFi+mmlumggSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IuWwjuiIqi1ob3Zlci0xMjgwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNzQuMDAwMDAwLCAtMTMxLjAwMDAwMCkiIGZpbGw9IiMyMDIzMjIiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzQuMDAwMDAwLCAxMzEuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNODAsMCBDODIuMjA5MTM5LC00LjA1ODEyMjUxZS0xNiA4NCwxLjc5MDg2MSA4NCw0IEw4NCwzMiBDODQsMzQuMjA5MTM5IDgyLjIwOTEzOSwzNiA4MCwzNiBMOCwzNiBDNS43OTA4NjEsMzYgNCwzNC4yMDkxMzkgNCwzMiBMNCwyMS45MzggTDAuNSwxOCBMNCwxNC4wNjMgTDQsNCBDNCwxLjc5MDg2MSA1Ljc5MDg2MSw0LjA1ODEyMjUxZS0xNiA4LDAgTDgwLDAgWiIgaWQ9IkNvbWJpbmVkLVNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==);
                    width: 84px;
                    height: 36px;
                    left: 53px;
                    top: 7px;
                    color: #fff;
                    display: none;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
        .setting{
            position: absolute;
            width: 126px;
            margin: 0 auto;
            padding-left: 20px;
            display: flex;
            align-items: center;
            bottom: 40px;
            left: 50%;
            transform: translateX(-50%);
            color: #a8a5a4;
            img{
                width: 30px;
                height: 30px;
                margin-right: 10px;
            }
        }
    }
    @media screen and (max-width: 1280px) {
        #menu{
            width: 90px;
            ul{
                li{
                    a{
                        width: 50px;
                        height: 50px;
                        padding: 0;
                        border-radius: 26.5px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .list-icon{
                            margin-right: 0px;
                        }
                        span{
                            display: none;
                        }
                    }
                    
                }
                li:hover{
                    .tip{
                        display: flex;
                    }
                }
            }
            .setting{
                width: 50px;
                span{
                    display: none;
                }            
            }
        }
        

    }
    // #menu.close{
    //     width: 85px;
    //     ul{
    //         li{
    //             a{
    //                 width: 40px;
    //                 padding: 11px 0;
    //                 border-radius: 30px;
    //                 .list-icon{
    //                     width: 15px;
    //                     height: 15px;
    //                 }
    //                 .list-title{
    //                     opacity: 0;
    //                     height: 0;
    //                     position: absolute;
    //                 }
    //             }
    //         }
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/components/landlord/Menu.vue